import isString from 'lodash/isString';

type GetValueProps = (
  theme: object | (string | number)[],
  key?: string | number | null,
  fallback?: string | null,
) => object | (string | number)[] | string | number | undefined | null;

type GetTheme = (
  path?: string | number,
  fallback?: string | null,
) => ({
  theme,
}: {
  theme: object | (string | number)[];
}) => object | (string | number)[] | string | number | undefined | null;

export const getValue: GetValueProps = (theme, key, fallback) => {
  const currentKeys = key && isString(key) ? key.split('.') : [key];

  for (let p = 0; p < currentKeys.length; p++) {
    // @ts-ignore
    theme = theme && !isString(theme) ? theme[currentKeys[p]] : undefined;
  }

  return theme === undefined ? fallback : theme;
};

export const getTheme: GetTheme =
  (path, fallback = null) =>
  ({ theme }) =>
    getValue(theme, path, fallback);

export default getTheme;
